export const isAuthenticated = () => {
  if (typeof window !== "undefined") {
    const token = localStorage.getItem("token");
    if (!token) return false;
    return !!token;
  }
  return false;
};
